import { WS_CONNECT, WS_CONNECTED, WS_DISCONNECT, WS_DISCONNECTED, APP_SHOW_ERROR, MODAL_LOCATION } from './constants'
import { getErrorConfig } from '../utils/requests'

export * from './App/actions'
export * from './Cart/actions'

export const wsConnect = () => ({
  type: WS_CONNECT,
})

export const wsConnected = () => ({
  type: WS_CONNECTED,
})

export const wsDisconnect = () => ({
  type: WS_DISCONNECT,
})

export const wsDisconnected = err => dispatch => {
  dispatch({
    type: WS_DISCONNECTED,
  })
  if (err) {
    const error = getErrorConfig(err.code)
    dispatch({
      type: APP_SHOW_ERROR,
      payload: { ...error, location: MODAL_LOCATION.PRE_CHAT, code: err.code },
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/actionCreators.js